
$(document).ready(function () {
    //JQuery for site-wide use
    console.log('Listening Room script loaded');

    // start CRewards tabs
    $('ul.nav-tabs li a[role="tab"]').click(function (e) {
        $('ul.nav-tabs li.active').removeClass('active')
        $(this).parent('li').addClass('active')
        e.preventDefault();
    });
    $('ul.nav-tabs li').click(function (e) {
        $('ul.nav-tabs').toggleClass('options-expanded');
    });


    //On click updating
    $('ul.nav-tabs li a[role="tab"]').click(function (e) {
        //$("html, body").animate({ scrollTop: 0 }, "fast");
        $('ul.nav-tabs li.active').removeClass('active')
        $(this).parent('li').addClass('active')
        var tabTop = $(this).offset().top - 150;
        window.scrollTo(0, tabTop);

        //var newValue = e.target.getAttribute("aria-controls");
        //const urlParams = new URLSearchParams(window.location.search);
        //urlParams.set('tab', newValue);
        //window.location.search = urlParams;

        var newValue = e.target.getAttribute("aria-controls");
        const url = new URL(window.location.href);
        url.searchParams.delete('tab');
        url.searchParams.delete('updatepassword'); 
        url.searchParams.set('tab', newValue);
        window.history.replaceState(null, null, url); // or pushState

        e.preventDefault();
    });
    // end CRewards tabs

    //START On submit form turn HTML into HTML
    setTimeout(function () {
        if ($('.alert-danger').length) {
            console.log('form error');
            $('html,body').animate({
                scrollTop: $('.alert-danger').offset().top
            }, 1000);
        }


        var submitDiv = $('.lr-booking-submit-header-container div:contains("lr-booking-submit-header")')[0];
        if (submitDiv) {
            var a = $(submitDiv)[0].textContent;
            $(submitDiv).html(a);
            console.log('text ready');

            setTimeout(function () {
                $('html,body').animate({
                    scrollTop: $('.lr-booking-submit-header-submitted').offset().top
                }, 1000);
            }, 1000);
        }

    }, 1000);
    //END end submit form logic


    //magnificPopup Example
    //$('.video-carousel-item').magnificPopup({
    //    disableOn: 575,
    //    type: 'iframe',
    //    iframe: {
    //        markup: '<div class="mfp-iframe-scaler">' +
    //            '<div class="mfp-close"></div>' +
    //            '<iframe class="mfp-iframe" frameborder="0" allowfullscreen></iframe>' +
    //            '<div class="mfp-title">Some caption</div>' +
    //            '</div>'
    //    },
    //    callbacks: {
    //        markupParse: function (template, values, item) {
    //            values.title = item.el.attr('title');
    //        }
    //    },
    //    preloader: false,
    //    fixedContentPos: true
    //});


    //SlickJS Examples
    //SlickJS Carousel for Media Carousel
    //$('.media-carousel').slick({
    //    autoplay: true,
    //    arrows: true,
    //    dots: false,
    //    prevArrow: $('.arrow-left'),
    //    nextArrow: $('.arrow-right')
    //});
    //SlickJS Carousel for Featured News Stories
    //$('.slick-responsive-carousel').slick({
    //    dots: true,
    //    infinite: false,
    //    speed: 300,
    //    slidesToShow: 2,
    //    slidesToScroll: 1,
    //    initialSlide: 0,
    //    variableWidth: true,
    //    centerMode: false,
    //    responsive: [
    //        {
    //            breakpoint: 1024,
    //            settings: {
    //                slidesToShow: 1,
    //                slidesToScroll: 1
    //            }
    //        },
    //        {
    //            breakpoint: 600,
    //            settings: {
    //                slidesToShow: 1,
    //                variableWidth: false
    //            }
    //        }
    //        // You can unslick at a given breakpoint now by adding:
    //        // settings: "unslick"
    //        // instead of a settings object
    //    ]
    //});
});


//Shrinking Top Nav snippet
//$(document).on("scroll", function () {
//    if
//    ($(document).scrollTop() > 100) {
//        $("#ContentTopNavigation_T7A285BBA015_Col00").addClass("shrink");
//    }
//    else {
//        $("#ContentTopNavigation_T7A285BBA015_Col00").removeClass("shrink");
//    }
//});